<template>
    <div class="SignInForm content">
        <div class="SignInForm--title">
            <h2 class="SignInForm--title-heading">Welcome back.</h2>
            <p class="SignInForm--title-description">Sign into your account here</p>
        </div>

<!--        <div class="w-100 d-flex justify-content-between">
            <button class="social-button mr-lg-4 mr-sm-3 mr-2"
                    @click="googleLogIn"
            >
                <img class="SignInForm&#45;&#45;social-logo"
                     src="../../assets/img/svg/google-logo.svg"
                >
                Google Sign In
            </button>
            <button class="social-button"
                    @click="facebookLogIn"
            >
                <img class="SignInForm&#45;&#45;social-logo"
                     src="../../assets/img/svg/facebook-logo.svg"
                >
                Facebook Sign In
            </button>
        </div>

        <div class="w-100 mt-4 d-flex align-items-center">
            <hr :style="{ 'width': '100%', 'border': '1px solid #e9edf0' }">
            <p class="mb-0 mx-3">Or</p>
            <hr :style="{ 'width': '100%', 'border': '1px solid #e9edf0 ' }">
        </div>-->

        <form @submit.prevent="submit"
              novalidate>
            <div class="form-group">
                <label for="email">Email</label>
                <input id="email"
                       v-model="form.userName"
                       v-validate="'required|email|max:100'"
                       name="email"
                       type="email"/>
                <div class="error">{{ errors.first('email') }}</div>
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input id="password"
                       v-model="form.password"
                       v-validate="'required'"
                       name="password"
                       type="password"/>
                <div class="error">{{ errors.first('password') }}</div>
            </div>
            <div class="SignInForm--form-description">
                <div class="SignInForm--form-description-forgot"
                     @click="changeLoginForm('forgot-password-form')">
                    Forgot your password?
                </div>
            </div>
            <button type="submit"
                    :class="['SignInForm--button', 'primary-btn', isLoading && 'ie-spinner']"
                    :disabled="!formValidated || formPristine"
                    v-spinner="isLoading"
            >
                Login
            </button>

            <button class="social-button mt-4"
                    @click="googleLogIn"
            >
                <img class="SignInForm--social-logo"
                     src="../../assets/img/svg/google-logo.svg"
                >
                Google Sign In
            </button>
        </form>

        <div class="d-flex align-items-center justify-content-center w-100 mt-md-4 mt-2">
            <p class="SignInForm--footer-info">Don`t have an account?</p>
            <div class="SignInForm--footer-registration"
                 @click="changeLoginForm('sign-up-form')">
                Sign up
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {FormMixin} from '@/mixins/FormMixin';
    import * as ErrorExceptions from '@/constants/error-exceptions';

    export default {
        name: 'SignInForm',

        components: {
            Checkbox: () => import('@/components/controls/Checkbox'),
        },
        
        data() {
            return {
                form: {
                    userName: '',
                    password: ''
                }
            }
        },

        mixins: [FormMixin],

        computed: {
            ...mapGetters(['isLoading'])
        },
        
        methods: {
            ...mapActions([
                'logIn',
                'showSpinner',
                'createNotification',
                'verificationChangeEmail',
                'facebookLogIn',
                'googleLogIn',
                'changeLoginForm'
            ]),

            async submit() {
                const valid = await this.$validator.validateAll();

                if (!valid) return;

                this.$validator.reset();
                try {
                    this.showSpinner(true);
                    await this.logIn(this.form);
                } catch (e) {
                    this.showSpinner(false);
                    if (e.status === 401 || e.status === 400) {
                        this.errors.add({
                                field: 'password',
                                msg: 'You have entered an invalid email or password'
                            }
                        );
                    } else if (e.status === 403 && e.data === ErrorExceptions.DEACTIVATED_ACCOUNT) {
                        this.$router.push({ name: 'ERRORS', params: this.$router.currentRoute.params, query: { exception: e.data } });
                    } else if (e.status === 403 && e.data === ErrorExceptions.UNVERIFIED_EMAIL) {
                        localStorage.setItem('user-name', this.form.userName);
                        this.$router.push({ name: 'CONFIRM_REGISTRATION', params: this.$router.currentRoute.params });
                    }
                } finally {
                    this.showSpinner(false);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .SignInForm {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 10% 0;
        @media screen and (max-width: 425px) {
            margin-top: 15px;
        }

        .form-group {
            padding-top: 10px;
            @media screen and (max-width: 425px) {
                padding-top: 1em;
                margin-bottom: 15px;
            }
        }


        &--title {
            margin-bottom: 5%;

            &-heading {
                text-align: center;
                margin-bottom: 5%;
            }

            &-description {
                font-weight: 400;
                font-size: 14px;
                color: $WhiteGrey;
            }
        }

        &--social-logo {
            width: 25px;
            height: 25px;
            margin-right: 5%;
            border-radius: 50%;
        }

        &--form-description {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            &-forgot {
                font-weight: 400;
                font-size: 14px;
                color: $SoftBlue;
                cursor: pointer;

                &:hover {
                    color: $BlueHover;
                    text-decoration: underline;
                }
            }
        }

        &--button {
            margin-top: 20px;
            border-radius: 24.5px;
            font-weight: 500;
            @media screen and (max-width: 425px) {
                margin-top: 30px;
            }
        }

        &--footer {
            &-info {
                margin-bottom: 0;
                margin-right: 10px;
                font-weight: 400;
                font-size: 14px;
                color: $Dark;
                @media screen and (max-width: 425px) {
                    font-size: 16px;
                }
            }

            &-registration {
                margin-bottom: 0;
                font-weight: 400;
                font-size: 14px;
                color: $SoftBlue;
                @media screen and (max-width: 425px) {
                    font-size: 16px;
                }

                &:hover {
                    color: $BlueHover;
                    text-decoration: underline;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/no-auth/SignInForm.vue